import React,{useState,useEffect} from 'react'
import EcxDatatable from '../../../../common/datatable/EcxDatatable'
import { useNavigate } from 'react-router-dom'
import surveyService from '../../../../../services/survey.service'
import {toast} from 'react-toastify'
import { useParams } from 'react-router-dom'


function ClinicSurvey() {

    const navigate = useNavigate()
    const [surveyList,setSurveyList] = useState([])
    const {clinicId} = useParams()

    useEffect(()=>{

        getAllSurveys()
    },[])

    const getAllSurveys  = ()=>{
        surveyService.getAllSurveys(clinicId)
        .then(res=>{
            setSurveyList(res.data)
        })
        .catch(err=>{
            console.log(err)
        })
    }
    const columns = [
        {name:'Id',selector:row=>row.id,sortable:true},
        {name:'Title',selector:row=>row.title,sortable:true},
        {name:'Description',selector:row=>row.description,sortable:true},
        
    ]
    const handleClick = (id)=>{
        navigate('edit/'+id)
    }
    return (
        <>
        <div className="p-3">
     
       
            <EcxDatatable
                                                 columns={columns}
                                                 data={surveyList}
                                                 pagination={true}
                                                 paginationPerPage={5}
                                                 paginationRowsPerPageOptions={[5, 10, 15]}
                                                 highlightOnHover
                                                 striped
                                               
                                             />
          </div>
        </>
  )
}

export default ClinicSurvey